{
  "title": "Clientes",
  "search": "Buscar",
  "table": {
    "id": "ID",
    "name": "Nombre",
    "email": "Correo electrónico",
    "suitabilityScore": "Puntuación de idoneidad",
    "complianceIssue": "Problema de cumplimiento",
    "createdAt": "Creado en",
    "completedAt": "Completado en",
    "organization": "Organización",
    "province": "Provincia",
    "dateOfBirth": "Fecha de nacimiento",
    "notCompleted": "Sin completar",
    "custodianAccountNumbers": "Números de cuenta",
    "goals": "Metas",
    "portfolioRiskLevels": "Niveles de riesgo",
    "marketValue": "Total de activos"
  }
}
